import React from 'react';
import clsx from 'clsx';
import styles from './Input.module.scss';

type Props = {
  type?: string;
  name?: string;
  value?: string;
  defaultValue?: string;
  size?: number,
  disabled?: boolean;
  placeholder?: string;
  id?: string;
  className?: string;
  variant?: 'full' | 'middle' | 'picker' | 'pickerMiddle' | 'pickerFull';
};

const Input = React.forwardRef<HTMLInputElement, Props>((props, ref): JSX.Element => {
  const {
    type = 'text',
    name,
    value,
    defaultValue,
    size,
    disabled = false,
    placeholder,
    id,
    className,
    variant,
    ...other
  } = props;

  return (
    <input
      ref={ref}
      type={type}
      name={name}
      value={value}
      defaultValue={defaultValue}
      size={size}
      disabled={disabled}
      placeholder={placeholder}
      id={id}
      className={clsx(
        styles.root,
        variant && styles[variant],
        className
      )}
      {...other}
    />
  );
});

export default React.memo(Input);